import type { VideoModelOption } from './types';

/** Same formula the server settles with: seconds × per-second price + per-video price. */
export function estimateJobTokens(model: VideoModelOption, durationSeconds: number): number {
  return Math.ceil(model.tokensPerSecond * durationSeconds + model.tokensPerVideo);
}

export function formatNumber(value: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(value);
}

export function formatBytes(bytes: number, locale: string): string {
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(value)} ${units[unit]}`;
}

/** Modes present in the model list, keeping the server order. */
export function availableModes(models: VideoModelOption[]): string[] {
  return [...new Set(models.map((model) => model.mode))];
}
